import { expVal, expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import {
	LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA,
	FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';

import { isWithinLastWeek } from '../utils/isWithinLastWeek.ts';

export const useShouldShowNewUserTemplates = () => {
	const isLicensed = useIsLicensed();

	const { data, loading, error } = useGetOnboardingState(
		fg('cfind-4971-improved-templates-bar-gate')
			? [
					...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA),
					FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE,
				]
			: [...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		!isLicensed,
	);
	const { revampedBpqaShownAt, foundingAdminRevampedBpqaEligible } = deserializeState(data);
	const shownAtWithinLastWeek = isWithinLastWeek(revampedBpqaShownAt);

	if (!isLicensed) {
		return { showNewUserTemplates: false, loading: false };
	}

	if (loading) {
		return { showNewUserTemplates: false, loading: true };
	}

	if (error) {
		return { showNewUserTemplates: false, loading: false, error };
	}

	return {
		showNewUserTemplates:
			(foundingAdminRevampedBpqaEligible &&
				// This is where we actually enroll users for CFIND-4971, this means that if a Founding Admin is going to see a templates bar
				// 50% will see the old one and 50% will see the improved one
				expVal('cfind-4971-improved-templates-bar', 'isEnabled', false)) ||
			(shownAtWithinLastWeek &&
				(expValEquals('land_users_in_editor_with_revamped_bpqa_new', 'cohort', 'experiment') ||
					expValEquals(
						'land_users_in_editor_with_revamped_bpqa_existing',
						'cohort',
						'experiment',
					))),
		loading: false,
	};
};
